export * from '@mui/joy/Typography';
// export type { TypographyProps } from '@mui/joy/Typography';
export { default as Typography } from './Typography';
export type { FortressTypographyProps, FortressTypographyProps as TypographyProps } from './Typography';
